// The page of a paged search that an export holds: the rows on screen, never
// the rest of the results.

const count = (value: number): string => value.toLocaleString("en-US");

// "Results 51–100 of 1,234", the note of an export of one page; "All 12
// results" when the page holds every result
export const pageNote = (offset: number, shown: number, total: number): string =>
  offset === 0 && shown >= total
    ? `All ${count(total)} results`
    : `Results ${count(offset + 1)}–${count(offset + shown)} of ${count(total)}`;
